import i18n from './locale';
import axios from 'axios';
import path from 'path';
import { extractPayload } from '@shared/utils';
import {
    getBrowserLocale,
    getLocaleCookie,
    setLocaleCookie,
} from '../lib/language/language';
import { API_PREFIX } from '@shared/globals';

export const MODULE_NAME = 'locale';

export const ACTIONS = {
    UPDATE_LOCALE_AND_COOKIE: MODULE_NAME + '/updateLocaleAndCookie',
    DETERMINE_USER_LANG: MODULE_NAME + '/determineUserLang',
    LOAD_SUPPORTED_LANGUAGES: MODULE_NAME + '/loadSupportedLanguages',
    UPDATE_DEFAULT_LANGUAGE: MODULE_NAME + '/updateDefaultLanguage',
    UPDATE_LANGUAGE_FILE: MODULE_NAME + '/updateLanguageFile',
};
export const MUTATIONS = {
    SET_LOCALE: 'setLanguage',
    SET_AVAILABLE_LANGUAGES: 'setAvailableLanguages',
    SET_COUNTRY_CODE: 'setCountryCode',
    SET_I18N_LANG: 'setI18nLang',
    SET_DEFAULT_LANGUAGE: 'setDefaultLanguage',
    SET_IP_COUNTRY_CODE: 'setIpCountryCode'
};
export const GETTERS = {
    GET_SUPPORTED_LANGUAGES: 'getSupportedLanguages',
    GET_COUNTRY_CODE: 'getCountryCode',
    GET_DEFAULT_LANGUAGE: 'getDefaultLanguage',
    GET_LOCALE: 'getLocale',
    GET_IP_COUNTRY_CODE: 'getIpCountryCode'
};
let api = axios.create({
    baseURL: `/${API_PREFIX}/static/config`,
    headers: {},
    withCredentials: true,
});

export default {
    namespaced: true,
    state: {
        supportedLanguages: [],
        countryCode: '',
        ipCountryCode: ''
    },

    mutations: {
        setAvailableLanguages(state, lang) {
            state.supportedLanguages = [...lang];
        },
        setI18nLang(_, { messages, locale }) {
            i18n.setLocaleMessage(locale, messages);
            i18n.locale = locale;
        },
        setDefaultLanguage(_, language) {
            i18n.fallbackLocale = language;
        },
        setCountryCode(state, countryCode) {
            state.countryCode = countryCode;
        },
        setIpCountryCode(state, ipCountryCode) {
            state.ipCountryCode = ipCountryCode;
        }
    },

    getters: {
        getLocale() {
            return i18n.locale;
        },
        getSupportedLanguages(state) {
            return state.supportedLanguages;
        },
        getDefaultLanguage(_) {
            return i18n.fallbackLocale;
        },
        getCountryCode(state) {
            return state.countryCode.toLowerCase();
        },
        getIpCountryCode(state) {
            return state.ipCountryCode.toLowerCase();
        }
    },

    actions: {
        updateCountryCode({ commit }, countryCode) {
            commit(MUTATIONS.SET_COUNTRY_CODE, countryCode);
        },
        updateLocaleAndCookie(_, lang) {
            // Sets a site-wide cookie
            setLocaleCookie(lang);
            document.location.reload();
        },
        updateLanguageFile({ commit, getters }, lang) {
            let countryCode = getters[GETTERS.GET_COUNTRY_CODE];
            return api
                .get(path.join('strings', countryCode, lang))
                .then((response) => {
                    commit(MUTATIONS.SET_I18N_LANG, {
                        messages: response.data,
                        locale: lang,
                    });
                    // set lang attribute on html element
                    document.documentElement.setAttribute('lang', lang);
                    return lang;
                });
        },
        loadSupportedLanguages({ commit, getters }) {
            let countryCode = getters[GETTERS.GET_COUNTRY_CODE];
            return api
                .get(path.join('languages', countryCode))
                .then(extractPayload)
                .then((payload) => {
                    commit(MUTATIONS.SET_AVAILABLE_LANGUAGES, payload.available);
                    commit(MUTATIONS.SET_DEFAULT_LANGUAGE, payload.default);
                    return payload;
                });
        },
        loadFromIpCountry({ commit }) {
            // get from ip API ipCountry code
            return axios.get(`https://ipapi.co/json/`, {headers: {}}).then(response => {
                console.log('ip response: ', response && response.data && response.data.country_code)
                if (response && response.data && response.data.country_code) {
                    commit(MUTATIONS.SET_IP_COUNTRY_CODE, response.data.country_code);
                }
                return true;
            }).catch(()=>{})
        },
        determineUserLang({ dispatch, getters }) {
            // Get user country
            let localeCookie = getLocaleCookie(),
                browserLocales = getBrowserLocale(),
                lang = '',
                supportedLanguages = getters[GETTERS.GET_SUPPORTED_LANGUAGES];

            // compare if match the available language
            if (!lang) {
                let ipCountryCode = getters[GETTERS.GET_IP_COUNTRY_CODE];
                console.log('ip country code: ', ipCountryCode)
                if (ipCountryCode && supportedLanguages.includes('en-' + ipCountryCode)) {
                    lang = 'en-' + ipCountryCode;
                }
            }
            console.log('ip Country lang: ', lang)
            // Still no language - use default language
            if (!lang) {
                lang = getters[GETTERS.GET_DEFAULT_LANGUAGE];
            }
            console.log('final lang: ', lang)

            // Check cookie
            if (localeCookie && supportedLanguages.includes(localeCookie)) {
                lang = localeCookie;
            }
            console.log('locale cookie lang: ', lang)

            // Check browser locale
            if (!lang && browserLocales) {
                browserLocales = Array.isArray(browserLocales)
                    ? browserLocales
                    : [browserLocales];

                // Check if we support that locale
                lang = supportedLanguages.find((supportedLang) => {
                    return browserLocales.find(
                        (browserLocale) => supportedLang === browserLocale
                    );
                });

                // Check best next (language only)
                if (!lang) {
                    lang = supportedLanguages.find((supportedLang) => {
                        return browserLocales.find((browserLocale) => {
                            return (
                                browserLocale.split('-')[0] ===
                                supportedLang.split('-')[0]
                            );
                        });
                    });
                }
            }
            console.log('browser lang: ', lang)


            return dispatch('updateLanguageFile', lang);
        },
    },
};



// WEBPACK FOOTER //
// ./shared/locale/store.js